// AUTO-GENERATED FILE. Do not edit.
import { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import { PokeType } from "types/pokemon/poke-type";

export const stunfisk_galar: PokeData = {
  "id": 10180,
  "name": "stunfisk-galar",
  "height": 7,
  "weight": 205,
  "base_experience": 165,
  "types": [
    PokeType.GROUND,
    PokeType.STEEL
  ],
  "api_moves": [
    "tackle",
    "water-gun",
    "fissure",
    "flail",
    "mud-slap",
    "endure",
    "metal-claw",
    "revenge",
    "metal-sound",
    "muddy-water",
    "iron-defense",
    "bounce",
    "mud-shot",
    "sucker-punch",
    "snap-trap"
  ],
  "moves": [
    "tackle",
    "fissure",
    "mud-slap",
    "metal-claw",
    "metal-sound",
    "mud-shot",
    "metal-rush",
    "sandstorm",
    "magnitude",
    "magnet-pull",
    "iron-defense",
    "earth-power",
    "gear-up"
  ],
  "evolution_chain": {
    "id": 313,
    "item": null,
    "species": [
      {
        "name": "stunfisk",
        "order": 619,
        "types": [
          PokeType.GROUND,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 188,
    "speed": 60,
    "ability_power": 152
  },
  "stat_changes": [],
  "catch_rate": 75,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": "galar"
} as const;
